import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Form } from 'reactstrap';
import { useFormik } from 'formik';
import { validationSchema } from './validation';
import Moment from 'moment';
import MonitoringPoints from '../../../UI/MonitoringPoints/MonitoringPointsV2';
import TimeSelector from '../../../UI/TimeSelector/TimeSelectorV2';
import { Alert, Button, Dropdown } from '../../../UI/Common';
import helper from '../../../../utils/helper';
import ReactSelect from '../../../UI/ReactSelect';

function generateObjectFromURL(search) {
  const {
    groupId,
    sensorIds,
    fromDate = Moment().startOf('month').toDate(),
    toDate = new Date(),
    timeId = 7,
  } = helper.parseQueryString(search);
  return { groupId, sensorIds, fromDate, toDate, timeId };
}

const TrendChartPage = (props) => {
  const { t, isFetchingReport, errors: errs, groups, history } = props;
  const params = generateObjectFromURL(props.location.search);
  const {
    values,
    errors,
    setFieldTouched,
    setFieldValue,
    touched,
    handleSubmit,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: params,
    validationSchema,
    onSubmit: () => props.onRunReport(values),
  });
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errs} />
        <Form>
          <ReactSelect
            required
            containerStyle={{ width: '30%' }}
            name="groupId"
            label="Group"
            options={groups}
            value={values.groupId}
            onChange={({ value }) => {
              setFieldValue('groupId', value);
              setFieldValue('sensorIds', '');
              history.push(
                `${helper.compileQueryString({
                  ...params,
                  groupId: value,
                  sensorIds: '',
                })}`,
              );
            }}
            valueKey="id"
            labelKey="name"
            invalid={touched.groupId}
            error={errors.groupId}
          />
          <MonitoringPoints
            groupId={values.groupId}
            sensorIds={values.sensorIds}
            onSelect={(sensorIds) => {
              setFieldTouched('sensorIds', false);
              setFieldValue('sensorIds', sensorIds.join(','));
              history.replace(
                `${helper.compileQueryString({
                  ...params,
                  sensorIds: sensorIds.join(','),
                })}`,
              );
            }}
            invalid={errors.sensorIds && touched.sensorIds}
            error={errors.sensorIds}
          />
          <TimeSelector
            timeId={values.timeId}
            fromDate={values.fromDate}
            toDate={values.toDate}
            onChange={(fromDate, toDate, timeId) => {
              setFieldValue('fromDate', fromDate);
              setFieldValue('toDate', toDate);
              setFieldValue('timeId', timeId);
              history.replace(
                `${helper.compileQueryString({
                  ...params,
                  fromDate,
                  toDate,
                  timeId,
                })}`,
              );
            }}
          />
          <Button
            id="submit-filter"
            loading={isFetchingReport}
            onClick={handleSubmit}
          >
            {t('Run Report')}
          </Button>
        </Form>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(TrendChartPage);
